import { useEffect, useState } from "react";
import Inbox from '../src/components/inbox'

function App() {
  //xobaso8672@cubene.com
  // const [email, setEmail] = useState("667ihpct8k@sfolkar.com");
  //const [email, setEmail] = useState("7kd3u8qjud@bloheyz.com");
  //const [email,setEmail] = useState("yatot57243@aersm.com")
  //7kd3u8qjud@bloheyz.com
  const [navVisible, setNavVisible] = useState(false);
  const [email,setEmail] = useState("")
  const [isBtnLoading, setBtnIsLoading] = useState(false);
  const [mails, setMails] = useState([]);
  const [coped,setCoped]=useState(false)
  const [showModal,setShowModal]=useState(false)
  const [modalTxt, setModalTxt] = useState("Loading...");
  const [modalTitle, setModalTitle] = useState("");
  const [countdown, setCountdown] = useState(10);
  const copyToClipboard = () => {
    setCoped(!coped)
    navigator.clipboard.writeText(email);
  };
  const fetchEmailAndMessages = () => {
    fetch("https://tempapi-w3c1.vercel.app/api/new")
      .then((res) => res.json())
      .then((data) => {
        setEmail(data?.email);
        //handleReloadClick(data?.email);
      });
  };

  const handleReloadClick = () => {
    setBtnIsLoading(true);
    console.log(email)
    fetch(`https://tempapi-w3c1.vercel.app/api/messages?email=${email}`)
      .then((res) => res.json())
      .then((data) => {
        //console.log("called data",data)
        setMails(data);
        setCountdown(10)
        setBtnIsLoading(false);
      });
  };

  // useEffect(() => {
  //   fetchEmailAndMessages();

  //   const interval = setInterval(() => {
  //     handleReloadClick();
  //   }, 2000);

  //   return () => clearInterval(interval);
  // }, []);
  useEffect(() => {
    //fetchEmailAndMessages();
    const interval = setInterval(() => {
      if (email) {
        handleReloadClick(email);
        //setCountdown(10)
      }
    }, 10000);
    const countdownTimer = setInterval(() => {
      setCountdown(prevCountdown => prevCountdown - 1);
    }, 1000);
    return () => {
      clearTimeout(interval);
      clearInterval(countdownTimer);
    };
  }, [email]);
  useEffect(() => {
    fetchEmailAndMessages()
  }, [])
  const handleMailClick = (id, title) => {
    fetch(`https://tempapi-w3c1.vercel.app/api/message?id=${id}`)
      .then((res) => res.text())
      .then((data) => {
        console.log("data",data)
        setModalTxt(data);
      });
    setModalTitle(title);
    setShowModal(true);
  };
  const formatGmail=(mail)=>{
    let inputString = mail.from

// Remove the surrounding double quotes
let withoutQuotes = inputString.replace(/"/g, '');

// Split the string into an array using '<' and '>' as separators
let parts = withoutQuotes.split('<');

// Extract the name and email
let name = parts[0].trim();
let email = parts[1] ? parts[1].replace('>', '').trim() : '';
var data={
    email,
    name
}
 return data
  }

  const modifiedHtmlContent = modalTxt?.replace(/<a(?![^>]*target="_blank")/g, '<a target="_blank"');
  return (
    <>
      <div className="flex-col bg-pink-900 shadow-md w-full min-h-screen overflow-auto" role="navigation" aria-label="main navigation">
       <h3 className="h-14 flex  items-center justify-center text-3xl font-bold space-x-2 ">
            <img src={require("./mail.png")} className={"h-10 w-10"} alt="mail"></img>
            <p className={"text-red-300 mr-2"}>Spoof</p>
            <p className={"text-blue-300 mr-2"}>Email</p>
         </h3>
        <div className="flex flex-col lg:flex-row  bg-pink-900 w-full px-0  pt-4 items-center justify-center">
        
       
          <div className={' flex flex-col items-center justify-center h-96 w-[90%] md:w-[90%] lg:w-[30%] border-2 rounded	border-2'}>
     
          <h4 className={"text-2xl font-bold  text-white text-center"}>Your Email Address is Ready</h4>
          <div className={`w-full flex m-2 md:w-[90%]  ${navVisible ? "is-active" : ""}`}>
          
          <div className=" w-full flex bg-pink-800  drop-shadow-md rounded">
            <div className="w-full flex">
              <input
                className=" bg-pink-800 p-2 outline-none  text-sm md:text-lg text-white rounded-full w-full flex"
                type="text"
                value={email}
                readOnly
              />
            </div>
          <div className="bg-blue-800  rounded p-2 flex bg-white  hover:bg-blue-800 transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300">
              <button className="button is-link" onClick={copyToClipboard} title="copy email">
              <img src={require("./copy.png")} className={"h-5 w-5"} alt="copy"></img>
              </button>
            </div>
          
          </div>
          
        </div>
         <div className="flex ">
        <button
                className={`button flex items-center p-2 rounded bg-pink-800 is-link is-outlined is-small ${
                  isBtnLoading ? "is-loading" : ""
                }`}
                style={{ marginLeft: "3px" }}
                onClick={handleReloadClick}
                disabled={isBtnLoading}
              >
                 <img className="h-6 w-10 flex-none rounded-full " src={require('./refresh.png')} alt="" />
           
              </button>
              <button
                className={`button  flex items-center space-x-2 p-2 rounded bg-pink-800 is-link is-outlined is-small ${
                  isBtnLoading ? "is-loading" : ""
                }`}
                style={{ marginLeft: "3px" }}
                onClick={()=>{
                  window?.location?.reload()
                }}
                disabled={isBtnLoading}
              >
                <img className="h-5 w-6 flex-none rounded-full mr-2" src={require('./edit.png')} alt="" />
           
              </button>
              </div>
        </div>
          {/* <h3 className="h-14 flex items-center justify-center text-3xl font-bold ">
            <img src={require("../mail.png")} className={"h-10 w-10"}></img>
            <p className={"text-red-300 mr-2"}>Temp</p>
            <p className={"text-blue-300 mr-2"}>Emails</p>
           
            
          </h3>
          <div className={'mt-12 flex flex-col items-center justify-center h-48 w-[30%] border-dashed rounded	border-2'}>
     
          <h4 className={"text-2xl font-bold mb-2 text-white"}>Your Email Address</h4>
          <div className={`navbar-menu flex w-64 ${navVisible ? "is-active" : ""}`}>
          <div className=" w-full flex ">
            <div className="w-full">
              <input
                className="bg-blue-900 drop-shadow-xl p-2 outline-none text-white rounded-full w-full flex"
                type="text"
                value={mail}
                readOnly
              />
            </div>
            <div className=" bg-blue-300  rounded-full p-2 ml-1 flex">
              <button className="button is-link" onClick={copyToClipboard}>
              <img src={require("./copy.png")} className={"h-5 w-8"}></img>
              </button>
            </div>
          </div>
        </div>
        </div> */}
        {/* <Inbox email={email} dataa={mails}></Inbox> */}
        <div className="bg-white min-h-96 mt-2 w-[90%] lg:w-[60%] ml-2 flex flex-col mb-3 rounded-md ">
             
             <div className="bg-pink-800 min-h-10 flex rounded-t flex items-center px-2 justify-between ">
                 <h1 className={'text-xl font-bold text-white'}>Inbox</h1>
                 <h1 className={'text-xl font-bold text-white hidden md:flex'}>Subject</h1>
             </div>  
           
             <ul role="list" className=" flex h-86 flex-col overflow-y-auto">
             
         {
           mails.length > 0 ?
         mails?.map((mail,index) => {
           return(
           <li key={index} >
         
            <button className="flex min-w-full px-3 border-b-[1px] py-2" onClick={()=> handleMailClick(mail?.id, mail?.subject)}>
           <img className="h-9 w-12 flex-none rounded-full bg-gray-50" src={require('./email.png')} alt="" />
           <div className=" flex w-full justify-between">
           <div className="min-w-0 px-3 flex-col text-start">
             <p className="text-sm font-semibold leading-6 text-gray-900">{formatGmail(mail)?.email}</p>
             <p className="mt-0 truncate text-xs leading-5 text-gray-500">{formatGmail(mail)?.name}</p>
           </div>
           <div className="min-w-0 px-3 flex-col text-start">
             <p className="text-sm font-semibold leading-6 text-gray-900 hidden md:flex">{mail?.subject}</p>
           </div>
           </div>
         </button>
        </li>
        );
       })
        :
        <div className={"flex w-full justify-center items-center"}>
           <h1>No Mail Found....</h1>
        </div>
       }
       </ul>
         {showModal ? (
       <>
         <div
           className="justify-center w-full  items-center flex overflow-hidden  fixed inset-0 z-50 outline-none focus:outline-none"
         >
           <div className="relative h-[90%] w-[90%] my-6 mx-auto overflow-hidden">
             <div className="border-0 h-full rounded-lg shadow-lg overflow-hidden relative flex flex-col w-full bg-white outline-none focus:outline-none">
               
               <div className="flex items-center justify-end p-2 border-t border-solid border-blueGray-200 rounded-b">
                 <button
                   className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                   type="button"
                   onClick={() => setShowModal(false)}
                 >
                   Close
                 </button>

               </div>
               <section className="relative p-6 flex-auto overflow-hidden">
           {/* <iframe
             srcDoc={modalTxt}
             style={{ width: "100%", height: "100%"}}
           ></iframe> */}
                                   <div dangerouslySetInnerHTML={{ __html: modifiedHtmlContent }} />
         </section>
             </div>
           </div>
         </div>
         <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
       </>
     ) : null}
     
        </div>
         
        </div> 
        <div className="px-8  md:px-14 lg:px-16  text-white mb-3">
        <h1 className={"text-2xl font-bold"}>What is spoof Emails</h1>

<ul>
  <li>
    <strong>Spoof emails</strong>, aka phishing emails, mimic reputable entities (e.g., banks, government agencies) to deceive recipients. They aim to extract sensitive information or lure users into clicking malicious links/attachments.
  </li>
</ul>

<h2>Anatomy of Spoof Emails</h2>
<ul>
  <li>
    <strong>Sender Address Spoofing</strong>
    <ul>
      <li><strong>Description:</strong> Sender's name may seem authentic, but scrutinize the email address for alterations.</li>
      <li><strong>Caution:</strong> Deceptive addresses mimic trusted sources.</li>
    </ul>
  </li>
  <li>
    <strong>Urgent Requests</strong>
    <ul>
      <li><strong>Description:</strong> Emails instill urgency/fear, coercing immediate action.</li>
      <li><strong>Caution:</strong> Beware of demands for quick responses or threats for non-compliance.</li>
    </ul>
  </li>
  <li>
    <strong>Phishing Links and Attachments</strong>
    <ul>
      <li><strong>Description:</strong> Hyperlinks may redirect to malicious sites; attachments could contain malware.</li>
      <li><strong>Caution:</strong> Hover over links to reveal destinations; scrutinize attachments before downloading.</li>
    </ul>
  </li>
  <li>
    <strong>Grammatical Errors and Poor Formatting</strong>
    <ul>
      <li><strong>Description:</strong> Lack of professionalism indicates fraudulent nature.</li>
      <li><strong>Caution:</strong> Look for grammatical mistakes, spelling errors, or inconsistent formatting.</li>
    </ul>
  </li>
</ul>

<h2>Protection Measures</h2>
<ul>
  <li>
    <strong>Stay Informed</strong>
    <ul>
      <li><strong>Action:</strong> Educate team on spoof email signs; update on emerging cyber threats.</li>
    </ul>
  </li>
  <li>
    <strong>Verify Requests</strong>
    <ul>
      <li><strong>Action:</strong> Confirm email legitimacy via official channels (phone, verified email).</li>
    </ul>
  </li>
  <li>
    <strong>Utilize Email Filters</strong>
    <ul>
      <li><strong>Action:</strong> Employ spam filters and security solutions to detect suspicious emails.</li>
    </ul>
  </li>
  <li>
    <strong>Keep Software Updated</strong>
    <ul>
      <li><strong>Action:</strong> Ensure email client, antivirus, OS are patched for security vulnerabilities.</li>
    </ul>
  </li>
  <li>
    <strong>Exercise Caution</strong>
    <ul>
      <li><strong>Action:</strong> When uncertain, refrain from clicking on links or downloading attachments.</li>
    </ul>
  </li>
</ul>
</div>
           <p className="px-8  md:px-14 lg:px-16 text-2xl font-bold text-white mb-3">Related Keywords:</p>
             <p className="mt-0 text-md leading-5 text-justify text-white px-8  md:px-14 lg:px-16">
             free, temporary, email, disposable, mail,temp emails, email address,temp mail, tempmail mail, tem email, temp mail email, temporary email, temp mailbox, disposable temporary email, disposable email, smailpro, burner email address, temporary email generator, temp mail generator, burner email generator, temporary email address, temp mail org, temp email address, temp mail gmail, gmail temp mail, temporary email and password, temp mail with password, temporary email with password, create temp mail, create temporary mail, temp mail com, free temporary email, free temp email, free temp mail, temporary email send, temporary email id, send email from temporary email, temp mail send, temp mail sender, tamp mail com, temp email id, temporary email to send mail, temporary email address to send email, send temp email, best temporary email, best temp mail, temp mail apk, temp mail plus, best disposable emails, best temp email, best temporary mail, disposable email address, temp mail for facebook, temporary mail id, temp mail id, temp mail ninja, create temporary email, create temporary email address, create temp email, temp mail disposable, tempmail gmail, temp business email, temp mail address, temporary email account, temporary mail address, another temp mail, another temporary mail, temporary email gmail, get temporary email, email for one time use, temp mail temporary email, temp mail app, temp mail pro, top 10 temporary email, temp mail service, temp mail number, temporary mail service, tempail email, temporary edu email, 10 temp mail, temporary mail box, gmail temporary email address, temp mail org en, temp google mail, temp mail and password, temp email com, 10 mail temp, 10 temp email, 10 minute temp mail, temp work email, temporary email app, temporary email with inbox, temp mail online, google temp mail, temp mail inbox, temporary email send and receive, your temporary email address, instant email address, custom temp mail, burner email account, temp mail disposable temporary email, free disposable email address, disposable emails that work, temporary email address generator, temp mail org email, temporary anonymous email, temp mail google, temp mail fake email, temp business mail, business temp mail, temporary email maker, send mail from temp mail, create a burner email, free temporary email address, temp mail new, 2nd temp mail, temp mail to send email, temporary email for verification, custom temporary email, temp mail gmail account, google temporary email, email temporary gmail, 10min temp mail, business email temporary, temp company email, free burner email, temp mail create, temporary email address for verification, temporary email id and password, 10 minute temp email, 10 minutes mails, all temp mail, all tempmail, temporary domain email, temp mail send email, temp mail with gmail domain, temporary email verification, gmail com temp mail, temporary email domain, advance temp mail, best burner email, create temporary email with custom domain, make a temporary email, temporary email for testing, temp work mail, another temp email, another temporary email, best temp mail for facebook, best temp mail service, temp business email address, temp mail with custom domain, temp mail business, temp corporate email, best free temporary email, temporary edu email generator, send email from temp mail, create temporary email gmail, best temp email generator, best temp mail app, best temp mail website, free temp business email, temp mail custom domain, temporary email with custom domain, burner email creator, email generator temporary email address, temp mail verification, temporary email address to send mail, apk temp mail, best temp mail site, make a burner email, temp professional email, send email with temporary email, email temp generator, best temporary email for facebook, temp edu mail for azure, 24 hour temp email, another mail temp, burner email gmail, temporary company email address, temp email to send emails, temp company email address, instant email creator, 10 minute mail temp mail, 10minutemail com facebook, brazil temp mail, business temp email, free business email temporary, 1 temp mail, 1 week temporary email, 10 minute mail gmail id, all the temp mail, another temp mail app, another temp mail com, best temporary email app, besttempmail, burner email website, create temporary business email, 10 min temp email, 10 minute mail temp, 10 minute mail temporary e mail, 10 minute temp mail net, aliexpress temp mail, anonymous temp mail, burner email site, burner email to send, burner email with password, temp mail business email, 10 email temp, 10 email temporary, 10 minute disposable email, 10 temporary email, 24 hour temp mail, 5emp mail, anothertempmail, burner email and password, burner email for facebook, burner email id, burner email online, change temp mail, 1 hour temp email, 10 minute email id with password, 10 minute mail temporary, 10minute temp mail, 20 minute temp mail, a temporary email, another temp mail disposable temporary, best disposable email address, best temp mail for instagram, best temp mail generator, best temporary email address, best temporary email website, burner account email, burner email address gmail, create temporary email domain, 1 day temporary email, 10 minute email id and password, 10 minute mail disposable email, 10 minute mail free anonymous temporary email, 10 minutes mail inbox, 10minutemail free temporary anonymous email, 10minutemail temporary email, 99 temp mail, 99tempmail, air mail temp, alilot temp mail, amazon temp mail, another temp mail apk, app temp mail, apps like temp mail, best burner email account, best free temporary email address, best temporary email 2021, best temporary email site, best temporary email sites, bulk temporary email, burner email account generator, changeable temp mail
            </p>
        <div className={'flex  h-14 justify-center items-center  mt-3 bg-black'}>
          {/* <h3 className="h-14 flex items-center justify-center text-3xl font-bold ">
            <img src={require("./mail.png")} className={"h-10 w-10"} alt="mail"></img>
            <p className={"text-red-300 mr-2"}>Temp</p>
            <p className={"text-blue-300 mr-2"}>Emails</p>
          </h3> */}
           <div>
           <ul class="list-none flex space-x-2 ">
             <li onClick={()=>{}} class={' hover:drop-shadow-xl cursor-pointer p-2 rounded-full text-white font-bold'}>@copyright by Spoof Email</li>
             
            </ul>
           </div>
          </div>
        </div>
    </>
  );
}

export default App;